import {
  BASE_POLICIES_URL,
  DEPLOYMENT_ENVIRONMENT,
  IS_DEV_ENV,
  IS_PROD_ENV,
} from 'consts/appConsts';

import { IS_EMBEDDED } from 'utils/queryParamHelpers';

function buildLink(urlString) {
  const linkParams = IS_EMBEDDED ? '?embedded=true' : '';

  return `${BASE_POLICIES_URL}/${urlString}${linkParams}`;
}

/**
 * Chime links
 * 1. "Chime Privacy Notice"
 * 2. "Chime Member Agreement"
 * 3. "Chime ATMs Article"
 */

export const chimePrivacyPolicyLink = buildLink('chime/privacy-policy/');
export const chimeUserAgreementLink = buildLink('chime/chime-user-agreement/');
export const chimeMemberAgreementLink = buildLink('chime/member-agreement/');
export const chimeSmsAgreementLink = buildLink(
  'chime/telephone-messaging-agreement/'
);
export const chimeCardProgramAddendumLink = buildLink(
  'chime-card-cash-rewards-addendum/'
);
export const atmFeesArticleLink =
  'https://help.chime.com/hc/en-us/articles/221405228-Does-Chime-charge-fees';

/**
 * Stride links
 */

export const strideDepositAgreementLink = buildLink(
  'stride/deposit-account-agreement/'
);

export const strideChimeCardDepositAgreementLink = buildLink(
  'stride/chime-card-deposit-account-agreement/'
);

export const strideSavingsAccountAgreementLink = buildLink(
  'stride/savings-account-agreement/'
);

export const chimeElectronicCommunicationAgreementLink = buildLink(
  'stride/electronic-communication-agreement/'
);

export const strideElectronicCommAgreementLink = buildLink(
  'stride/debit-electronic-communication-agreement/'
);

export const stridePrivacyPolicyLink = buildLink('stride/privacy-policy/');
export const strideSpotMeTermsAndConditions = buildLink('stride/spotme_terms/');

export const strideEFTLink = buildLink(
  'stride/electronic-fund-transfer-terms-conditions-for-safer-credit-building/'
);
export const strideChimeCardEFTLink = buildLink(
  'stride/chime-card-electronic-fund-transfer-terms-conditions-for-safer-credit-building/'
);
export const strideChimeCardAgreementLink = buildLink(
  'stride/chime-card-agreement/'
);
export const strideChimeCardSecuredDepositAccountAgreementLink = buildLink(
  'stride/chime-card-secured-deposit-account-agreement/'
);

/**
 * Bancorp links
 */

export const bancorpPrivacyPolicyLink = buildLink('bancorp/privacy-policy/');

export const bancorpElectronicCommAgreementLink = buildLink(
  'bancorp/electronic-communication-agreement/'
);

export const bancorpDepositAgreementLink = buildLink(
  'bancorp/deposit-account-agreement/'
);

export const bancorpChimeCardDepositAgreementLink = buildLink(
  'bancorp/chime-card-deposit-account-agreement/'
);

export const bancorpSpotMeTermsAndConditions = buildLink(
  'bancorp/spotme_terms/'
);

export const bancorpCreditCardAgreementLink = buildLink(
  'bancorp/chime-credit-card-agreement/'
);
export const bancorpSecuredDepositAgreementLink = buildLink(
  'bancorp/application-disclosure-and-secured-deposit-account-agreement/'
);
export const bancorpChimeCardSecuredDepositAccountAgreementLink = buildLink(
  'bancorp/chime-card-secured-deposit-account-agreement/'
);

export const bancorpEFTLink = buildLink(
  'bancorp/electronic-fund-transfer-terms-conditions-for-safer-credit-building/'
);
export const bancorpChimeCardEFTLink = buildLink(
  'bancorp/chime-card-electronic-fund-transfer-terms-conditions-for-safer-credit-building/'
);

export const bancorpChimeCardAgreementLink = buildLink(
  'bancorp/chime-card-agreement/'
);
/** Login link */

export const chimeLoginLink = IS_PROD_ENV
  ? 'https://member.chime.com/link/sign_in'
  : '/users/sign_in';
export const dismissToLogin = '#dismiss_to_login';
export const acceptDismiss = '#accept_dismiss';
export const chimeRecoveryLink = IS_PROD_ENV
  ? 'https://member.chime.com/member/reset/email?redirected_from_enrollment=true'
  : '/member/reset/email?redirected_from_enrollment=true';

/** chime-web-app link */
export const chimeWebHost = () => {
  if (IS_PROD_ENV) {
    return 'https://app.chime.com';
  } else if (IS_DEV_ENV) {
    return 'http://localhost:3000';
  } else {
    // qa or devN
    return `https://app-${DEPLOYMENT_ENVIRONMENT}.chime.com`;
  }
};

export const buildChimeWebLink = (path = '/') => {
  return `${chimeWebHost()}${path}`;
};
